import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import {
  getGlobalSettings,
  updateGlobalSetting,
  getGlobalSettingHistory,
} from "../api/globalSettings"

export const useGlobalSettings = () =>
  useQuery({
    queryKey: ["global-settings"],
    queryFn: getGlobalSettings,
    select: (data) => data?.data || [],
  })

export const useUpdateGlobalSetting = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateGlobalSetting,
    onSuccess: (response, variables) => {
      queryClient.invalidateQueries({ queryKey: ["global-settings"] })
      queryClient.invalidateQueries({
        queryKey: ["global-setting-history", variables.key],
      })
      toast.success(response?.message || "Setting updated")
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update setting"
      toast.error(message)
    },
  })
}

export const useGlobalSettingHistory = ({ key, offset, limit }) =>
  useQuery({
    queryKey: ["global-setting-history", key, offset, limit],
    queryFn: () => getGlobalSettingHistory({ key, offset, limit }),
    enabled: !!key,
    // Keeps the previous page on screen while the next one loads, so the
    // history table does not collapse to a spinner on every page change.
    placeholderData: (previous) => previous,
  })
